import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="additionsgruppe"
export default class extends Controller {
	static targets = ["summe", "summand"]
	static values = {
		summe: 0,
		nks: 2,
	}

	connect() {
		if (this.summeValue === 0) this.summeTarget.innerHTML = currency(0, this.nksValue)
	}

	summandTargetConnected() {
		this.addieren()
	}

	summandTargetDisconnected() {
		this.addieren()
	}

	// Private

	addieren() {
		if (this.hasSummeTarget) {
			this.summeValue = 0
			for (const summand of this.summandTargets) {
				this.summeValue += parseFloat(summand.dataset.betrag)
			}

			this.summeTarget.innerHTML = currency(this.summeValue, this.nksValue)
		}
	}
}
